<template>
  <v-list-item
    @click="
      $vuetify.goTo(item.link, {
        offset: $store.state.section.stickyHeader.height
      })
    "
  >
    <v-list-item-content>
      <v-list-item-title>{{ item.name }}</v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: 'SectionMobileMenuButton',
  props: {
    item: {
      type: Object,
      required: true
    },
    props: {
      type: Object,
      required: true
    }
  }
}
</script>
